import './checkout-gift-cards.scss';
